const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");

const browserOrigin =
  typeof window !== "undefined" ? window.location.origin : "";

export const isProductionBuild = process.env.NODE_ENV === "production";

export const appOrigin = trimTrailingSlash(
  isProductionBuild ? browserOrigin : process.env.REACT_APP_URL || browserOrigin
);

export const apiBaseUrl = `${appOrigin}/api`;

export const imageOrigin = trimTrailingSlash(
  isProductionBuild
    ? browserOrigin
    : process.env.REACT_APP_IMAGE_URI || appOrigin
);

export const chatOrigin = trimTrailingSlash(
  isProductionBuild
    ? browserOrigin
    : process.env.REACT_APP_CHAT_URL || appOrigin
);

export const socketOrigin = appOrigin;
